import { useMutation } from '@tanstack/react-query';

import { ServiceProviderFormSchemaValues } from 'src/features/serviceProvider/utils/formSchema';
import { ServiceProvider } from 'src/features/serviceProvider/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/sites/service-provider/:providerId/`;

type MutationFnType = typeof mutationFn;

interface DTO {
    data: ServiceProviderFormSchemaValues;
    providerId: string;
    parkingId: string;
}
const mutationFn = ({ providerId, parkingId, data }: DTO): Promise<ServiceProvider> => {
    return axios.put(formatResourcePath(RESOURCE, { providerId, parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateServiceProvider };
